/**
 * Tiny TTS helper. Uses window.speechSynthesis with an es-ES voice when available.
 * The browser caches voices asynchronously, so we call getVoices() lazily at speak time.
 */
export function speak(text, lang = "es-ES") {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  const trimmed = (text || "").toString().trim();
  if (!trimmed) return;

  try {
    // Cancel anything currently playing so messages don't pile up.
    window.speechSynthesis.cancel();

    const utter = new SpeechSynthesisUtterance(trimmed);
    utter.lang = lang;
    utter.rate = 1.0;
    utter.pitch = 1.0;
    utter.volume = 1.0;

    const voices = window.speechSynthesis.getVoices?.() || [];
    const esVoice =
      voices.find((v) => v.lang && v.lang.toLowerCase() === "es-es") ||
      voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("es"));
    if (esVoice) utter.voice = esVoice;

    window.speechSynthesis.speak(utter);
  } catch (e) {
    console.warn("speechSynthesis failed", e);
  }
}

export function cancelSpeech() {
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  try {
    window.speechSynthesis.cancel();
  } catch {
    /* ignore */
  }
}
